import React, { useEffect, useState } from "react";
import { Calendar, Card, List, Tag, Spin, Alert, ConfigProvider } from "antd";
import { instance } from "../../API/API";
import dayjs from "dayjs";
import 'dayjs/locale/ru'; // Импортируем русскую локаль
import ru_RU from 'antd/locale/ru_RU'; // Импортируем русскую локаль для Ant Design

// Устанавливаем русскую локаль для dayjs
dayjs.locale('ru');

const PlanList = () => {
    const [plans, setPlans] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [selectedDate, setSelectedDate] = useState(dayjs());

    // Получаем начало и конец текущего месяца
    const getCurrentMonthRange = () => {
        const startOfMonth = dayjs().startOf('month').unix();
        const endOfMonth = dayjs().endOf('month').unix();
        return { start: startOfMonth, end: endOfMonth };
    };

    const [dates, setDates] = useState(getCurrentMonthRange());

    useEffect(() => {
        const fetchPlans = async () => {
            try {
                setLoading(true);

                const response = await instance.get(
                    `plans/get_plans.php?start=${dates.start}&end=${dates.end}`
                );

                if (response && response.data) {
                    // Проверяем, есть ли свойство plans или это сам массив
                    const plansData = response.data.plans || response.data;
                    setPlans(Array.isArray(plansData) ? plansData : []);
                }
            } catch (err) {
                setError(err.message);
                console.error("Ошибка при загрузке планов:", err);
            } finally {
                setLoading(false);
            }
        };

        fetchPlans();
    }, [dates]);

    // Безопасное преобразование timestamp в dayjs объект
    const safeDayjs = (timestamp) => {
        try {
            // Преобразуем в число и проверяем валидность
            const numTimestamp = parseInt(timestamp);
            if (isNaN(numTimestamp) || numTimestamp <= 0) {
                return null;
            }
            return dayjs.unix(numTimestamp);
        } catch (error) {
            console.error('Ошибка преобразования даты:', error);
            return null;
        }
    };

    // Функция для получения планов на конкретную дату
    const getPlansForDate = (date) => {
        if (!Array.isArray(plans)) return [];

        return plans.filter(plan => {
            if (!plan || !plan.used_date) return false;

            const planDate = safeDayjs(plan.used_date);
            if (!planDate || !planDate.isValid()) return false;

            return planDate.isSame(date, 'day');
        });
    };

    // Новая функция cellRender для замены dateCellRender и monthCellRender
    const cellRender = (current, info) => {
        if (info.type === 'date') {
            const datePlans = getPlansForDate(current);
            if (datePlans.length === 0) {
                return null;
            }

            return (
                <div style={{ padding: '2px' }}>
                    {datePlans.map(plan => (
                        <div
                            key={plan.id}
                            style={{
                                background: '#1890ff',
                                color: 'white',
                                borderRadius: '2px',
                                padding: '2px 4px',
                                margin: '1px 0',
                                fontSize: '12px',
                                cursor: 'pointer'
                            }}
                            onClick={(e) => {
                                e.stopPropagation();
                                window.open(`https://gdapp.org/current_plan/?id=${plan.id}`, '_blank');
                            }}
                        >
                            План #{plan.id}
                        </div>
                    ))}
                </div>
            );
        }

        // Для месяца ничего не рендерим
        if (info.type === 'month') {
            return null;
        }

        return null;
    };

    // Обработчик изменения даты в календаре
    const onPanelChange = (value, mode) => {
        if (mode === 'month') {
            const startOfMonth = value.startOf('month').unix();
            const endOfMonth = value.endOf('month').unix();
            setDates({ start: startOfMonth, end: endOfMonth });
        }
    };

    // Получаем планы для выбранной даты
    const selectedDatePlans = getPlansForDate(selectedDate);

    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '400px' }}>
                <Spin size="large" tip="Загрузка планов..." />
            </div>
        );
    }

    if (error) {
        return (
            <Alert
                message="Ошибка"
                description={error}
                type="error"
                style={{ margin: '20px' }}
            />
        );
    }

    return (
        <ConfigProvider locale={ru_RU}>
            <div style={{ padding: '20px' }}>
                <h2>Планы работ на месяц</h2>

                <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
                    <div style={{ flex: '1', minWidth: '300px' }}>
                        <Calendar
                            value={selectedDate}
                            onSelect={setSelectedDate}
                            onPanelChange={onPanelChange}
                            cellRender={cellRender}
                            style={{ background: 'white' }}
                            fullscreen={true}
                        />
                    </div>
                </div>
            </div>
        </ConfigProvider>
    );
};

export default PlanList;